module.exports = __webpack_public_path__ + "img/logotipo.20ed44b1.png";